export const versionName = (number) => `v.${number}`;
